import ProductConfigManifest from "flow/manifests/ProductConfigManifest";
import ProductComponentManifestEx from "flow/manifests/ProductComponentManifestEx";

export default class ProductConfigManifestEx extends ProductConfigManifest {
    id: string;
    baseUrl: string;

    constructor(manifest: ProductConfigManifest, productId: string, baseUrl: string) {
        super();

        if (!manifest) {
            this.hide = true;
            return;
        }

        this.baseUrl = baseUrl;

        if (manifest.customOptionsComponent) {
            manifest.customOptionsComponent.id = productId;
            this.customOptionsComponent = new ProductComponentManifestEx(manifest.customOptionsComponent, baseUrl);
        }

        this.hide = manifest.hide;
        this.id = productId;
        this.inactiveReason = manifest.inactiveReason;
    }
}
